import { FoodMenuItem } from "../interfaces/FoodItem";
import { useMenuItemsQuery } from "./useMenuItemsQuery";


export const useFoodItemById = (id: string) : FoodMenuItem | undefined => {
    const { data: items, isLoading, error } = useMenuItemsQuery();
    const itemWrapped = items?.filter(item => item.id == id);
    return itemWrapped && itemWrapped.length == 1 ? itemWrapped[0] : undefined;
}